import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'precoVenda'
})

export class PrecoVendaPipe implements PipeTransform {

  transform(custo: number): any {

    return Math.round(custo)+1;

  }

}
